import { createSlice, PayloadAction, Dispatch } from '@reduxjs/toolkit';
import { AuditLog, AuditLogFilter, AuditLogState, APIError } from 'models';
import * as services from 'services';
import type { RootState } from 'store/store';

export const defaultState: AuditLogState = {
  data: [],
  isLoading: false,
  error: null,
};

// Export slice
export const auditLogSlice = createSlice({
  name: 'auditLog',
  initialState: defaultState,
  reducers: {
    getAuditLog: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    getAuditLogSuccess: (state, action: PayloadAction<AuditLog[]>) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    getAuditLogFailure: (state, action: PayloadAction<APIError>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetAuditLogState: () => {
      return defaultState;
    },
  },
});

// Export selectors
export const auditLogSelector = (state: RootState) => state.auditLog;

// Export actions
export const {
  getAuditLog,
  getAuditLogSuccess,
  getAuditLogFailure,
  resetAuditLogState,
} = auditLogSlice.actions;

// Export reducer
export const auditLogReducer = auditLogSlice.reducer;

// Export thunk
export function fetchAuditLog(filters: AuditLogFilter[]) {
  return async (dispatch: Dispatch) => {
    dispatch(getAuditLog());
    try {
      const response = await services.fetchAuditLogs(filters);
      dispatch(getAuditLogSuccess(response.data));
    } catch (e: any) {
      dispatch(getAuditLogFailure(e));
    }
  };
}

export function fetchUserAuditLogById(userId: string) {
  return async (dispatch: Dispatch) => {
    dispatch(getAuditLog());
    try {
      const response = await services.fetchUserAuditLogsById(userId);
      dispatch(getAuditLogSuccess(response.data));
    } catch (e: any) {
      dispatch(getAuditLogFailure(e));
    }
  };
}
